import React, { Component } from 'react'
import Table, { TableHead, TableBody, TableRow, TableCell, styles as tableStyles } from 'components/CollapsibleTable'
import { FlexDataItem } from 'components/FlexDataView'
import CommissionIcon from '@material-ui/icons/LocalOffer'
import Typography from '@material-ui/core/Typography'
import StyleSheet from 'styles'
import {NumberDisplay} from 'components/numbers'

export class Commissions extends Component {
  get commissions() {
    return this.props.allocation.commissions
  }

  get currencyCode() {
    return this.props.allocation.currency.code
  }

  get currencyPrefix() {
    return this.props.allocation.currency.prefix
  }

  get ticker() {
    return this.props.allocation.ticker || 'Unit';
  }

  render = () => {
    const isEquity = this.props.allocation.dealSheet.typeOfIssuance === 'equity'

    return <FlexDataItem size="xlarge">
      <Typography variant='subtitle1'><CommissionIcon />Commission</Typography>
      {/*if*/ this.commissions.length ?
        <div className={styles.tableContainer}>
          <Table className={tableStyles.secondary}>
            <TableHead>
              <TableRow>
                <TableCell className={styles.responsiveCell}>Party</TableCell>
                <TableCell className={styles('numeric', 'related')}>Rate</TableCell>
                { !isEquity &&  <TableCell className={styles('numeric')} /> }
                <TableCell className={styles('numeric', 'related')}>Collected</TableCell>
                { !isEquity && <TableCell className={styles('numeric')} /> }
                <TableCell className={styles('numeric', 'related')}>Remaining</TableCell>
                { !isEquity && <TableCell className={styles('numeric')} /> }
              </TableRow>
            </TableHead>
            <TableBody>
              {this.commissions.map(commission =>
                <TableRow key={commission.id}>
                  <TableCell mobileHeading>
                    {commission.partyName}
                  </TableCell>
                  <TableCell className={styles('numeric')} mobileLabel="Rate">
                    {commission.coinPercentage}% {this.currencyCode}
                  </TableCell>
                  { !isEquity && <TableCell className={styles('numeric', 'related')}>
                    {commission.tokenPercentage}% {this.ticker}
                  </TableCell> }
                  <TableCell className={styles('numeric')} mobileLabel="Collected">
                    <NumberDisplay prefix={this.currencyPrefix} suffix={this.currencyCode}>{commission.coinCollected}</NumberDisplay>
                  </TableCell>
                  { !isEquity && <TableCell className={styles('numeric', 'related')}>
                    <NumberDisplay suffix={this.ticker}>{commission.tokenCollected}</NumberDisplay>
                  </TableCell> }
                  <TableCell className={styles('numeric')} mobileLabel="Remaining">
                    <NumberDisplay prefix={this.currencyPrefix} suffix={this.currencyCode}>{commission.coinRemaining}</NumberDisplay>
                  </TableCell>
                  { !isEquity && <TableCell className={styles('numeric', 'related')}>
                    <NumberDisplay suffix={this.ticker}>{commission.tokenRemaining}</NumberDisplay>
                  </TableCell> }
                </TableRow>
              )}
            </TableBody>
          </Table>
        </div>
        /*else*/:
        <div style={{padding: 15}}>
          <Typography variant="subtitle1">No commissions to show here</Typography>
        </div>
      }
    </FlexDataItem>
  }
}

export default Commissions

export const styles = StyleSheet({
  tableContainer: {
    paddingTop: '15px',
    '& .mobile-heading': {
      marginBottom: 10,
    },
    '& table.collapsed $related': {
      paddingTop: '0 !important'
    }
  },
  related: {},
  numeric: {
    textAlign: 'right'
  }
})